/**
 *
 * Contact Information
 *
 */

import React, {Component} from 'react';
import Helmet from 'react-helmet';
import FormValidation from 'tcomb-form';

//lib
import AppAPI from '../lib/api';
import AppUtil from '../lib/util';

// Components
import Loading from '../components/general/Loading';
import Error from '../components/general/Error';
import FormView from '../components/general/FormView';

/* Component ==================================================================== */
class Terms extends Component {

  showEmailAddress = () => {
    this.setState({showEmail: true});
  };


  sendMessage = (credentials) => {
    if (credentials) {
      this.setState({form_values: credentials}, () => {
        this.setState({resultMsg: {status: 'One moment...'}});
        AppAPI.contact.post('', {
          'name': credentials.Name,
          'email': credentials.Email,
          'phone': credentials.Phone,
          'company': credentials.Company,
          'message': credentials.Message
        })
          .then(() => {
            this.setState({resultMsg: {success: 'Success'}},
              () => {
                setTimeout(() => {
                  this.setState({resultMsg: {status: ''}, formSuccess: true});
                }, 500);
              });
          })
          .catch((err) => {
            const error = AppAPI.handleError(err);
            this.setState({resultMsg: {error}});
          });
      });
    }
  };

  render = () => {

    const {loading, form_fields, form_values, options, error, resultMsg, showEmail, formSuccess} = this.state;


    if (loading) return <Loading/>;
    if (error) return <Error text={error}/>;

    return (
      <div className="index screen-container">
        <Helmet>
          <title>Contact us</title>
        </Helmet>

        <div className={'main-container container'}>
          <div className={'row justify-content-md-center'}>
            <div className={'col-sm-12 col-lg-8 col-md-10'}>

            </div>
          </div>

          <div className={'row justify-content-md-center'}>
            <div className={'col-sm-12 col-lg-8 col-md-10'}>
              <h1 className={'text-center'}>Contact Renzo</h1>
              <div className={'spacer-20'}/>
              <h4 className={''}>Renzo is a Saas based Property Management System.</h4>
              <p>We're excited to hear from you! Whether you're a potential customer, industry pro,
                curious tester, or guest blogger, we'd love hear what have to say. Please don't hesitate to reach out
                with questions, comments, feedback, or just a quick hello.</p>
              {formSuccess ?
                <div>
                  <div className={'p-3 mt-3 mb-0 text-center'}>
                    <div className={'col-md-12 p-lg-2'}>
                      <h1><span className={'fas fa-check-circle green-cl'}/> Thank you. </h1>
                      <p>We have received your request.</p>
                      <p>One of our representatives will contact you shortly</p>
                    </div>
                  </div>
                </div> :
                <FormView
                  formFields={form_fields}
                  formValues={form_values}
                  formOptions={options}
                  formAction={this.sendMessage}
                  formActionName={'Talk to US'}
                  statusMsg={resultMsg}
                  colType={2}
                />
              }
              <hr/>
            </div>
          </div>
          <div className={'spacer-20'}/>
          <div className={'row justify-content-md-center'}>
            <div className={'col-sm-12 col-lg-8 col-md-10'}>
              <div className={'spacer-20'}/>
              <div className={'row'}>
                <div className={'col-sm-12 col-md-6'}>
                  <p>You can also e-mail to&nbsp;
                    {showEmail === true ? <span>r@renzo.in or support@renzo.in</span> :
                      <span onClick={() => this.showEmailAddress()} className={'ul link'}><u>Click to See email
                        address.</u></span>}</p>
                </div>

                <div className={'col-sm-12 col-md-6'}>
                  <h5>Mailing address</h5>
                  <p>
                    Renzo Solutions Inc<br/>
                    2035 Sunset Lake Road,<br/>
                    Newark 19702
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };


  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: false,
      showEmail: false,
      resultMsg: {
        status: '',
        success: '',
        error: ''
      },
      form_fields: FormValidation.struct({
        Name: FormValidation.String,
        Company: FormValidation.maybe(FormValidation.String),
        Email: AppUtil.validEmail,
        Phone: FormValidation.maybe(AppUtil.validPhone),
        Message: FormValidation.String
      }),
      form_values: {},
      options: {
        fields: {
          Phone: {
            help: 'International Format.'
          },
          Message: {
            numberOfLines: 4,
            multiline: true,
            type: 'textarea'
          }
        }
      },
      formSuccess: false
    };
  }

}

export default Terms;


// WEBPACK FOOTER //
// ./src/containers/Contact.js